import React, { PropTypes,  Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as toursActions from '../actions/tours';
import Map from '../components/Map';
import Header from '../components/layout/Header';
import { Link } from 'react-router';
import Helmet from "react-helmet";

class ContactsPage extends Component {
    shoulComponentUpdate() {
        return false;
    }

    componentWillMount() {


        this.mapConfig = Object.assign({}, this.props.mapConfig);

        this.props.toursActions.setMapConfig({
            contacts: true,
            center: {
                lat: 66.03387226547608,
                lng: 99.619140625
            },
            zoom: 1
        });

    }

    componentWillUnmount() {

        this.props.toursActions.setMapConfig({contacts: false});

    }

    render () {

        let {tour, seo, translations} = this.props;



        return (
            <div>
                <Helmet
                    title={(seo.title)?seo.title:translations['contacts__title']}
                />
                <div className="section__content section__content_controls">
                    <Header />

                    {false &&
                        <div className="container overview" ref="tourContainer">
                            <div >
                                <span className="overview__type"><span className="overview__type_required">Discovery</span>nature</span>
                                <h1>
                                    <Link
                                        to={"/tour/" + (tour.id)}>
                                        {tour.title}
                                        </Link>
                                </h1>




                            </div>


                        </div>
                    }
                </div>
            </div>
        );
    }
}




function mapStateToProps (state) {
    return {
        map: state.tours.map,
        mapConfig: state.tours.mapConfig,
        seo: state.user.seo,
        translations: state.user.translations
    }
}

function mapDispatchToProps (dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactsPage)




// WEBPACK FOOTER //
// ./src/common/containers/ContactsPage.js